import { AnimatorManager } from "./AnimatorManager";
import { GameObject } from "@needle-tools/engine";

/**
 * This class is used to calculate how long the user has been away from the tab or minimized the browser window.
 */
export class TabFocus {
  private startTime: number | null;
  private totalTimeAway: number; //Its possible we dont need to woeey about total time away but in case they do a series of short tabs away we can track it
  private animatorManager: AnimatorManager;

  constructor() {
    this.startTime = null;
    this.totalTimeAway = 0;
    this.animatorManager =
      GameObject.findObjectOfType<AnimatorManager>(AnimatorManager)!; // Add '!' to assert that the value is not null
    this.setupListeners();
  }

  private setupListeners(): void {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        this.focusLost();
      } else {
        this.focusedRegained();
      }
    });
  }

  private startTimer(): void {
    this.startTime = Date.now();
  }

  private focusLost(): void {
    this.startTimer();
  }

  private focusedRegained(): void {
    this.stopTimer();
  }

  private stopTimer(): void {
    if (this.startTime != null) {
      const timeAway = Date.now() - this.startTime;
      this.totalTimeAway += timeAway;
      this.startTime = null; // Reset start time

      this.updateRaceProgression(timeAway);
    }
  }

  private updateRaceProgression(timeAway: number) {
    this.animatorManager =
      GameObject.findObjectOfType<AnimatorManager>(AnimatorManager)!;
    if (!this.animatorManager) {
      return;
    }
    //convert milliseconds to seconds
    timeAway = timeAway / 1000;
    this.animatorManager.setAnimatorToSpecificTime(timeAway);
  }
}
